import React, {useState,useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import * as S from '../SrpLeftBlock/SrpLeftBlock.styles';

import FiltersBlock from '../FiltersBlock/FiltersBlock';
import SrpFilterLoader from '../SrpLoader/SrpFilterLoader/SrpFilterLoader';
import {
  srpFiltersSelector,
  journeyTypeSelector,
  dataLoadingSelector
} from './../../../../containers/SRP/redux/selectors';
import {
  filterCollapse,
  toggleIsLoadingAction,
} from './../../../../containers/SRP/redux/actions';

import {addRemoveArrayOperation, getInitSelectedFilters} from './../../../../containers/SRP/Utils';
import {scrollEletoView} from './../../../../containers/Common/Utils';
import {pushga,pushEcommerceGAEvent} from 'ga-utils'
import {SrpGAEvents} from './../../../../config/ga-config'
import {updateSelectedBus,updateRTCView} from './../../../../containers/SRP/redux/actions';
import { allFiltersApplied } from '../../../../utils/ctaHelper'
import { pushOmniEvents } from '../../../..//utils/PushEvents/Omniture/utils'

const SrpLeftBlock = props => {
  const dispatch = useDispatch();
  const {filters} = useSelector(srpFiltersSelector);
  const journeyType = useSelector(journeyTypeSelector);
  const srpDataLoading = useSelector(dataLoadingSelector);
  const {
    boardingPoints,
    droppingPoints,
    operators,
    amenities,
    collapsedFilter,
    collapsedFilterItemCount,
    popularFilters,
    single_seat
  } = filters;
  const [activeSearchVal, setActiveSearchVal] = useState({});
  const [activeSearchType, setActiveSearchType] = useState('');
  const {selectedFilters, setSelectedFilters} = props;
  return (
    <S.SrpLeftBlockLayoutDiv>
    {srpDataLoading ?  <SrpFilterLoader /> :
      <FiltersBlock
        boardingPoints={
          activeSearchType === 'boardingPoint' || activeSearchVal['boardingPoint']
            ? getFilteredPoints(boardingPoints[journeyType], activeSearchVal,'boardingPoint')
            : boardingPoints[journeyType]
        }
        droppingPoints={
          activeSearchType === 'droppingPoint' || activeSearchVal['droppingPoint']
            ? getFilteredPoints(droppingPoints[journeyType], activeSearchVal,'droppingPoint')
            : droppingPoints[journeyType]
        }
        operators={
          activeSearchType === 'operator' || activeSearchVal['operator']
            ? getFilteredOperators(operators[journeyType], activeSearchVal,'operator')
            : operators[journeyType]
        }
        resetActiveSearchVal={(val)=>{
          if (val) {
            let obj = Object.assign({},activeSearchVal);
            obj[val] = ''
            setActiveSearchVal(obj);
     
          }
       
          
        }}
        amenities={amenities}
        popularFilters={popularFilters}
        single_seat={single_seat}
        showAllBoardingPoints={!(collapsedFilter.indexOf('boardingPoint') !== -1)}
        showAllDroppingPoints={!(collapsedFilter.indexOf('droppingPoint') !== -1)}
        showAllOperators={!(collapsedFilter.indexOf('operator') !== -1)}
        showAllAmenities={!(collapsedFilter.indexOf('amenities') !== -1)}
        itemDisplayCount={collapsedFilterItemCount}
        onFiltersReset={evt => {
          const val = evt.target.dataset.val;
          let filters = Object.assign({}, selectedFilters);
          if (val === 'resetAll') {
            setSelectedFilters(Object.assign({}, getInitSelectedFilters(true)));
            props.clearHorizontalFilterCards()
          } else {
            filters[val] = [];
            setSelectedFilters(filters);
          }
          dispatch(updateSelectedBus(''));
          dispatch(updateRTCView(''))
   
 
        }}
        onFilterSelect={(selectedFilterType, selectedValue, selectedFiltersName?: string) => {
          let filters = Object.assign({}, selectedFilters);
         let selected = true;
          if (selectedFilterType === 'operator') {
            if (filters[selectedFilterType][selectedValue]) {
              selected = false;
              delete filters[selectedFilterType][selectedValue];
            } else {
              filters[selectedFilterType][selectedValue] = selectedFiltersName;
            }
          } 
          else if(selectedFilterType === 'single_seat'){
            filters[selectedFilterType] = selectedValue
          }
          else {
            if(filters[selectedFilterType].indexOf(selectedValue) !== -1){
             selected = false;
            }
           
            filters[selectedFilterType] = addRemoveArrayOperation(
              filters[selectedFilterType],
              selectedValue,
            ); 
            if(!selected){
            const eventDetails = {
              filter : {
                filterRemoved:selectedValue,
                appliedFiltersList : allFiltersApplied(filters)
              }
            }
            pushOmniEvents({eventName:'filterRemoval', details:eventDetails})
          }
          }
          props.clearHorizontalFilterCards()
          setSelectedFilters(filters);
          const idOfElToScrollTo = "#srpCardLayout";
          scrollEletoView(idOfElToScrollTo,{
            behavior: 'smooth',block:'start'
       })

       const eventDetails = {
        filter : {
          appliedFiltersList : allFiltersApplied(selectedFilters)
        }
      }
       if(selected){
        eventDetails.filter.appliedFiltersList!==''?pushOmniEvents({eventName:'filterSelection', details:eventDetails}):null;
        pushga({
          event: SrpGAEvents.actions.bus_srp_filter.val,
          eventCategory: SrpGAEvents.category,
          eventAction: SrpGAEvents.actions.bus_srp_filter.val,
          eventLabel:function(){
            let val=SrpGAEvents.actions.bus_srp_filter.labels[selectedFilterType] || ''
            if(val && SrpGAEvents.actions.bus_srp_filter.addLabelCustomValue){
              val = `${val}${SrpGAEvents.actions.bus_srp_filter.labelCustomeValueSeperator}${selectedFilterType === 'operator' ? selectedFiltersName:selectedValue}`
            }
  
            return val;
          }()
        });
       }
       dispatch(updateSelectedBus(''));
 
      dispatch(updateRTCView(''))
         
        }}
        onFilterCollapse={filterCollapsedEle => {
          const val = filterCollapsedEle.target.dataset.val;
          dispatch(filterCollapse(val));
        }}
        activeSearchVal={activeSearchVal}
        activeSearchType={activeSearchType}
        onSearchTypeValChange={evt => {
          const ele = evt.target;
          if (ele) {
            let obj = Object.assign({},activeSearchVal);
            obj[ele.dataset.val] = ele.value
            setActiveSearchVal(obj);
     
          }
        }}
        onInputFocus={evt => {

         const ele = evt.target;
          if (ele) {
            let obj = Object.assign({},activeSearchVal);
            obj[ele.dataset.val] = ele.value
            setActiveSearchVal(obj);
     
            setActiveSearchType(ele.dataset.val);
     
          }
        }}
        onBlur={evt => {
          const ele = evt.target;
       
          if (ele) {
            //if we pass empty string in input value then it ignores and not changing the state of input box so need to set manually
      //    ele.value = '';
       
          }
        }}
        selectedFilters={selectedFilters}
/> }
    </S.SrpLeftBlockLayoutDiv>
  );
};

export default SrpLeftBlock;

function getFilteredPoints(data, activeSearchVal,activeSearchType) {
  if (!activeSearchVal[activeSearchType]) {
    return data;
  }
  const searchStr = activeSearchVal[activeSearchType].toLowerCase();
  const filteredResults = [];
  for (let i in data) {
    if (data[i].toLowerCase().indexOf(searchStr) !== -1) {
      filteredResults.push(data[i]);
    }
  }
  return filteredResults;
}

export function getFilteredOperators(data, activeSearchVal,activeSearchType = '') {
  if (!activeSearchVal[activeSearchType]) {
    return data;
  }
  const searchStr = activeSearchVal[activeSearchType].toLowerCase();
  const filteredResults = [];
  for (let i in data) {
    if (data[i].name.toLowerCase().indexOf(searchStr) !== -1) {
      filteredResults.push(data[i]);
    }
  }
  return filteredResults;
}
